<script setup>
defineProps({
  width: {
    type: Number,
    default: 20,
  },
  height: {
    type: Number,
    default: 20,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M10 3C10.3978 3 10.7794 3.15804 11.0607 3.43934C11.342 3.72064 11.5 4.10218 11.5 4.5C11.5 4.89782 11.342 5.27936 11.0607 5.56066C10.7794 5.84196 10.3978 6 10 6C9.60218 6 9.22064 5.84196 8.93934 5.56066C8.65804 5.27936 8.5 4.89782 8.5 4.5C8.5 4.10218 8.65804 3.72064 8.93934 3.43934C9.22064 3.15804 9.60218 3 10 3ZM10 8.5C10.3978 8.5 10.7794 8.65803 11.0607 8.93934C11.342 9.22064 11.5 9.60217 11.5 10C11.5 10.3978 11.342 10.7794 11.0607 11.0607C10.7794 11.342 10.3978 11.5 10 11.5C9.60218 11.5 9.22064 11.342 8.93934 11.0607C8.65804 10.7794 8.5 10.3978 8.5 10C8.5 9.60217 8.65804 9.22064 8.93934 8.93934C9.22064 8.65803 9.60218 8.5 10 8.5ZM11.5 15.5C11.5 15.1022 11.342 14.7206 11.0607 14.4393C10.7794 14.158 10.3978 14 10 14C9.60218 14 9.22064 14.158 8.93934 14.4393C8.65804 14.7206 8.5 15.1022 8.5 15.5C8.5 15.8978 8.65804 16.2794 8.93934 16.5607C9.22064 16.842 9.60218 17 10 17C10.3978 17 10.7794 16.842 11.0607 16.5607C11.342 16.2794 11.5 15.8978 11.5 15.5Z"
        fill="#8C8C8C"
      />
    </g>
  </svg>
</template>
